
import Vue from 'vue';
import Modal from '@/components/layout/modal.vue';
import ClinicalTrainingEvent from '@/store/modules/clinical-training-events/clinical-training-event';

export default Vue.extend({
  name: 'ClinicalTrainingEventParticipantsModal',
  components: {
    Modal,
  },
  props: {
    event: {
      type: Object as () => ClinicalTrainingEvent | null,
      default: null,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
});
